import { CircleHelp } from "lucide-react";
import { FC } from "react";

import { Card, CardHeader } from "@/components/ui/card";

export const ProductTabSettings: FC = () => {
  return (
    <Card>
      <CardHeader className="flex flex-col gap-6">
        <div className="flex flex-1 justify-center">
          <img
            src="/images/product-illustration.png"
            alt="Product Illustration"
            className="w-[280px] h-[190px]"
          />
        </div>
        <div className="flex gap-2 text-muted-foreground">
          <CircleHelp className="size-5" />
          <p className="text-sm">
            The Product name, image, and description is used display the product
            in your Webpage. To change this information, edit the Product from
            the SKU page.
          </p>
        </div>
      </CardHeader>
    </Card>
  );
};
